import { FormControl, Grid, makeStyles, Paper, Select, Theme, Typography } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import React from 'react';
import PrintButton from '../../buttons/PrintButton';
import { globalStyles } from '../../style/GlobalStyles';
import { DefaultInputProps } from '../../types/types';

// const useStyles = makeStyles((theme: Theme) =>
//     createStyles({
//         defaultText: {
//             padding: theme.spacing(2),
//             wordWrap: "break-word",
//             fontSize: 13
//         },
//         select: {
//             width: "10rem",
//         },
//     }),
// );
export default function ReportElaborazione(props: DefaultInputProps) {
    // const classes = useStyles();
    const gClasses = globalStyles();
    const { state } = props;
    /*Sarebbe bello fosse così ma non va bene*/
    let anni: string[] = [];
    anni.push("2026");
    anni.push("2027");
    anni.push("2028");
    anni.push("2029");
    anni.push("2030");

    return (
        <React.Fragment>
            <PrintButton></PrintButton>
            <Paper id="print" className={gClasses.fullWidthPaper} >
                {/* <div  > */}
                    <Typography id="t1" className={gClasses.defaultText} variant="h4">{state.nomeCognome.toUpperCase()}</Typography>
                    <Typography id="t2" className={gClasses.defaultText} variant="body1">In esecuzione dell'incarico ricevuto, abbiamo provveduto ad effettuare la verifica della convenienza all'adozione del regime fiscale forfetario, per il quale, dopo avere effettuato le necessarie verifiche, sussistono le condizioni di accesso, oppure del regime normale di determinazione dell'Iva e del reddito.</Typography>
                    <Typography id="t3" className={gClasses.defaultText} variant="body1">Sulla base dei dati in nostro possesso e delle informazioni che gentilmente ci ha fornito, che abbiamo considerato ricorrenti nell'esercizio della sua attività, abbiamo pertanto simulato il carico fiscale e contributivo gravante sull'uno e sull'altro regime fiscale.</Typography>
                    <Typography id="t4" className={gClasses.defaultText} variant="body1">L'elaborazione dei dati e delle informazioni ha dato i seguenti esiti:</Typography>
                    <Typography id="t5" className={gClasses.defaultText} variant="body1">Regime forfettario              carico complessivo annuo:					€ {state.confronto.G25_totale}</Typography>
                    <Typography id="t6" className={gClasses.defaultText} variant="body1">Regime normale                 carico complessivo annuo:					€ {state.confronto.M25_totale}</Typography>
                    <Typography id="t7" className={gClasses.defaultText} variant="body1">Il dettaglio di questi valori è rappresentato nel prospetto di confronto allegato.</Typography>
                    <Typography id="t8" className={gClasses.defaultText} variant="body1">Le abbiamo inoltre illustrato le caratteristiche salienti dei due regimi fiscali.</Typography>
                    <Typography id="t9" className={gClasses.defaultText} variant="body1">Infine, le abbiamo indicato quali sono gli adempimenti amministrativi previsti per il regime fiscale forfetario e per il regime normale di determinazione dell'Iva e del reddito, nonché le spese che dovrà sostenere per il loro espletamento.</Typography>
                    <Typography id="t10" className={gClasses.defaultText} variant="body1">Il tutto dettagliatamente descritto nel prospetto di confronto allegato.</Typography>
                    <Typography id="t11" className={gClasses.defaultText} variant="body1">Il suo consulente</Typography>
                    <Typography id="t12" className={gClasses.defaultText} variant="body1">___________________________</Typography>



                    <Typography id="t12" className={gClasses.defaultText} variant="body1">Sottoscrivendo la presente, Lei dichiara di avere preso visione delle risultanze del prospetto di confronto fra i due regimi fiscali, e di avere ricevuto le informazioni utili ad operare la scelta del regime da adottare.</Typography>

                    <Grid container>
                        <Typography id="t12" className={gClasses.defaultText} variant="body1">Conferma pertanto di volere adottare, per l'anno</Typography>
                        <FormControl className={gClasses.formControl}>
                        <Select
                            id="sAnno"
                            native
                            style={{ width: '70px' }}>
                            {anni.map((anno: any, index: number) => {
                                return (
                                    <option value={anno} key={index.toString()}>{anno}</option>
                                );
                            })}
                        </Select>
                        </FormControl>
                        <Typography className={gClasses.defaultText} variant="body1">il regime fiscale</Typography>
                        <FormControl className={gClasses.formControl}>
                        <Select
                            native
                            style={{ width: '170px' }}>
                            <option key="oForf" value="Forfettario">Forfetario</option>
                            <option key="oIva" value="Normale IVA e Reddito">Normale IVA e Reddito</option>
                        </Select>
                        </FormControl>
                    </Grid>
                    <Typography className={gClasses.defaultText} variant="subtitle1">{state.nomeCognome.toUpperCase()} ________________________</Typography>
                    <Typography className={gClasses.defaultText} variant="body1">Il ___________________________</Typography>
                {/* </div> */}

            </Paper>
        </React.Fragment>
    );
}